export const original = "an-original3";



// WEBPACK FOOTER //
// ./src/mod11.js